<template>
    <section ref="back" class="back container-fluid flex-grow-1 z-1 background-image">
		<div class="position-relative">
			<div class="w-100 vh-100 position-absolute top-0 start-0" ref="initial_background"></div>
		</div>
        <div class="row vh-100 sticky-top">
			<div class="col-12">
				<div class="px-4 d-flex align-items-center justify-content-center justify-content-md-start">
                    <h1 class="display-1 fs-2 fw-bold p-3 bg-white rounded-2 text-dark ms-0 ms-md-5 ms-lg-5">Projects</h1>
                </div>
			</div>
            <div class="content col-12 col-md-5 d-flex flex-column justify-content-evenly justify-content-lg-between z-1">
				<div class="mx-0 mx-lg-4 pb-4 pb-md-0">
					<div class="jumbo mx-0 mx-lg-5 shadow rounded-4 d-flex flex-column p-4">
						<h1 class="text-white text-start">{{ (currentProject) ? currentProject.name : 'Help' }}</h1>
						<p class="text-white text-start">{{ (currentProject) ? currentProject.description : `Don't worry kind person, keep scrolling you will pass through them projects as you go.`}}</p>
					</div>
				</div>
                <div class="px-0 px-lg-5 pb-5 py-lg-5 d-flex align-items-center justify-content-center" v-if="currentProject">
                    <!-- {{currentProject}} -->
                    <a :href="currentProject.github" target="_blank" class="btn btn-dark mx-1 w-auto shadow" v-if="currentProject.github">Github</a>
                    <a :href="currentProject.site" target="_blank" class="btn btn-light mx-1 w-auto shadow fw-medium" v-if="currentProject.site">Site</a>
					<a :href="currentProject.linkedin" target="_blank" class="btn btn-primary mx-1 w-auto shadow fw-medium" v-if="currentProject.linkedin">LinkedIn</a>
                </div>
                <div class="p-5 d-none d-sm-block"></div>
            </div>
            <div class="col-7 p-0 d-none d-md-flex align-items-center justify-content-center flex-column z-1">
                <!-- {{ projects }} -->
                <div v-if="projects" class="project-container p-4 w-100 d-flex align-items-center overflow-scroll snap-scroll">
                    <div v-for="(project, index) in projects" :key="project" :class="{ 'shrink' : !projectBackgrounds[index] }">
                        <ProjectCard ref="projectCard" class="apply-snap-scroll" :project="project" :display="projectBackgrounds[index]" />
                    </div>
                </div>
                <div v-if='false'>
                    <button class="btn p-2">
                        <i class="bi bi-arrow-left-circle fs-2 text-white"></i>
                    </button>
                    <button class="btn p-2">
                        <i class="bi bi-arrow-right-circle fs-2 text-white"></i>
                    </button>
                </div>
			</div>
        </div>
        <div ref="project_backgrounds">
			<!-- <div class="w-100 vh-100 bg-danger position-absolute start-0 top-0"></div> -->
            <div v-if="projects">
                <div v-for="(project, index) in projects" :key="project" class="vh-100 p-5 apply-snap-scroll">
                    <div ref="projectBackground" :index="index" class="project-background bg-white h-100 row" :style="{
                        'background-image': `url(${ project.image })`
                    }"></div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import ProjectCard from '@/components/ProjectCard.vue';

export default {
	name: "ProjectView",
    data(){
        return {
            projectBackgrounds: [],
            projectIndex: 0,
            currentProject: null
        }
    },
    async mounted(){
        await this.$store.dispatch('getData');
        // console.log('pjb: ', this.$refs.project_backgrounds.children[0].children);
        this.observer = new IntersectionObserver(this.handleIntersection, {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        });
        this.observer.observe( this.$refs.initial_background )  
        this.$nextTick(() => {
            this.$refs.back.style['height'] = (this.projects.length * 100 + 100).toString()+'vh';
            if(this.$refs.projectBackground){
                this.$refs.projectBackground.forEach( (elem) => {
                    this.projectBackgrounds.push(true);
                    let observer = new IntersectionObserver(this.handleIntersection, {
                        root: null,
                        rootMargin: '0px',
                        threshold: 0.5
                    });
                    observer.observe(elem);
                } )
            }
        });
    },
	components: {
		ProjectCard
	},
    methods: {
        handleIntersection(entries){
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.projectIndex = entry.target.getAttribute('index');
                    this.currentProject = (this.projects[this.projectIndex]) ? this.projects[this.projectIndex] : null;
                }
            });
            this.projectBackgrounds.forEach( (state, index) => {
                if( this.projectIndex && +this.projectIndex >= index ){
                    this.projectBackgrounds[index] = false
                } else {
                    this.projectBackgrounds[index] = true
                }
            } )
        },
        parseProjectName(name){
            return name.toLowerCase().split(' ').join('_');
        },
    },
    computed: {
        projects(){
            return this.$store.state.projects;
        }
    }
}
</script>
<style scoped>
.jumbo {
    backdrop-filter: blur(10px);
}
.background-image {
    background: linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.6), rgba(0,0,0,1)), url('https://firebasestorage.googleapis.com/v0/b/rezaar-s-portfolio.appspot.com/o/Images%2Fcode-problem.png?alt=media&token=bd559d34-ac09-4fde-b86a-fe96b5d1379d');
}
.back {
    height: 500vh;
}
.snap-scroll {
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
}
.project-background {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}
.shrink {
    animation-name: shrink;
    animation-duration: 1s;
    animation-fill-mode: forwards;
}

@keyframes shrink {
    50% {
        /* width: inherit; */
    }
    100% {
        width: 0%;
    }
}
</style>